module.exports = __webpack_public_path__ + "img/grp-part-4-corporate-1.cd468da8.png";